var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionsvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_92_407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4999 26.0357C20.4232 26.0357 26.0357 20.4233 26.0357 13.5C26.0357 6.57673 20.4232 0.964294 13.4999 0.964294C6.57666 0.964294 0.964233 6.57673 0.964233 13.5C0.964233 20.4233 6.57666 26.0357 13.4999 26.0357Z",
    stroke: "#152745",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0286 10.4143C10.0286 9.72772 10.2322 9.05655 10.6136 8.48568C10.9951 7.91481 11.5372 7.46986 12.1715 7.20712C12.8059 6.94438 13.5038 6.87563 14.1772 7.00958C14.8506 7.14352 15.4692 7.47414 15.9547 7.95963C16.4402 8.44512 16.7708 9.06367 16.9047 9.73706C17.0387 10.4105 16.9699 11.1084 16.7072 11.7428C16.4444 12.3771 15.9995 12.9192 15.4286 13.3007C14.8577 13.6821 14.1866 13.8857 13.5 13.8857V16.2",
    stroke: "#152745",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 18.5143C13.2712 18.5143 13.0475 18.5821 12.8572 18.7093C12.6669 18.8364 12.5186 19.0172 12.431 19.2286C12.3434 19.44 12.3205 19.6727 12.3651 19.8972C12.4098 20.1216 12.52 20.3278 12.6818 20.4896C12.8436 20.6515 13.0498 20.7617 13.2743 20.8063C13.4988 20.851 13.7314 20.8281 13.9429 20.7405C14.1543 20.6529 14.335 20.5046 14.4622 20.3143C14.5893 20.124 14.6572 19.9003 14.6572 19.6714C14.6532 19.3658 14.53 19.0738 14.3138 18.8576C14.0977 18.6415 13.8057 18.5183 13.5 18.5143Z",
    fill: "#152745",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_92_407"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionsvg);
export default __webpack_public_path__ + "static/media/questionsvg.8100add01df317c10a22fc3a9a7e1af9.svg";
export { ForwardRef as ReactComponent };